<!--二级团长列表-样品/合作-支持二级团筛选-->
<template>
	<el-select
		v-bind="$attrs"
		:loading="loading"
		v-model="team_institution_id"
		class="select-box"
		filterable
		clearable
		remote
		:placeholder="placeholder"
		:multiple="multiple"
		:multiple-limit="multipleLimit"
		:collapse-tags="collapseTags"
		@clear="clearSelect"
		@change="changeSelect"
		:remote-method="remoteMethodList"
		v-scroll-lazy-load="{
			loadData: shopLoadData,
			distance: 50,
			delay: 300,
			scrollBody: '.el-scrollbar__wrap',
			callback: fn => this.$once('hook:beforeDestroy', () => fn()),
		}"
	>
		<el-option v-for="item in list" :key="item.team_institution_id" :label="item.institution_name" :value="item[valueKey]">
			<div class="flex-row-align-center">
				<platform-icon :platformId="item.platform_id"></platform-icon>
				<span class="ml-8">{{ item.institution_name }}</span>
			</div>
		</el-option>
		<div class="align-center bottom pt-8 pb-8 yx-color-text-secondary fz-12">
			{{ !page_has ? '到底了~' : '加载中' }}
		</div>
	</el-select>
</template>
<script>
import { getInstitutionSelectList } from '@/api/secondColonelManage';
export default {
	components: {},
	props: {
		platformId: {
			type: [Number, String],
			default: '',
		},
		value: {
			type: [Number, String],
			default: '',
		},
		placeholder: {
			type: String,
			default: '请输入二级团长名称',
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		multipleLimit: {
			type: Number,
			default: 0,
		},
		collapseTags: {
			type: Boolean,
			default: false,
		},
		search_type: {
			type: String,
			default: 'institutionName', //机构名称
		},
		valueKey: {
			type: String,
			default: 'team_institution_id',
		},
	},
	data() {
		return {
			list: [],
			team_institution_id: '',
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			page_has: true,
			keyword: '',
			loading: false,
		};
	},
	watch: {
		platformId() {
			this.clearSelect();
		},
		value(val) {
			this.team_institution_id = val;
		},
		search_type(val) {
			this.clearSelect();
		},
	},
	methods: {
		async getList(e) {
			try {
				const { platformId, pageInfo } = this;
				const { list = [], page = {} } = await getInstitutionSelectList({ ...pageInfo, [this.search_type]: e, platformId });
				this.list = this.list.concat(list);
				this.page_has = page.page_has;
			} finally {
				this.loading = false;
			}
		},
		async remoteMethodList(e) {
			try {
				this.loading = true;
				const { platformId, pageInfo } = this;
				this.list = [];
				this.keyword = e;
				pageInfo.page_index = 1;
				const { list = [], page = {} } = await getInstitutionSelectList({ ...pageInfo, [this.search_type]: e, platformId });
				this.list = list;
				this.page_has = page.page_has;
			} finally {
				this.loading = false;
			}
		},
		changeSelect(val) {
			const item = this.list.find(v => {
				return v[this.valueKey] === val;
			});
			this.$emit('change', item);
			this.$emit('input', val);
		},
		shopLoadData() {
			if (!this.page_has) {
				return;
			}
			this.pageInfo.page_index++;
			this.getList(this.keyword);
		},
		clearSelect() {
			this.list = [];
			this.pageInfo.page_index = 1;
			this.page_has = true;
			this.keyword = '';
			this.getList();
		},
	},
	created() {
		this.getList();
	},
};
</script>
